/**
 * Color Swatch Image Swapping
 * Handles switching product images when color swatches are clicked on collection pages
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Color swatch image swapping initialized');

  // Use event delegation on the document for better reliability
  document.addEventListener('click', function(event) {
    // Check if the clicked element or its parent is a color swatch trigger
    const swatchLink = event.target.closest('.color-swatch-trigger');

    if (!swatchLink) {
      return; // Not a color swatch, let the event proceed normally
    }

    // Prevent navigation to product page
    event.preventDefault();
    event.stopPropagation();

    console.log('Color swatch clicked');

    const colorValue = swatchLink.dataset.colorValue;
    const productId = swatchLink.dataset.productId;

    console.log('Color:', colorValue, 'Product ID:', productId);

    if (!colorValue || !productId) {
      console.warn('Missing colorValue or productId', { colorValue, productId });
      return;
    }

    // Find the product card
    const productCard = document.querySelector(`[data-product-id="${productId}"]`);
    if (!productCard) {
      console.warn('Product card not found for ID:', productId);
      return;
    }

    // Find the media wrapper
    const mediaWrapper = productCard.querySelector('.card__media-wrapper');
    if (!mediaWrapper) {
      console.warn('Media wrapper not found');
      return;
    }

    // Hide all variant images
    const variantImages = mediaWrapper.querySelectorAll('.card__media-variant');
    variantImages.forEach(img => {
      img.style.display = 'none';
    });

    // Show the primary image by default
    const primaryImage = mediaWrapper.querySelector('.card__media-primary');
    if (primaryImage) {
      primaryImage.style.display = 'block';
    }

    // Find and show the variant image for the selected color
    const targetImage = mediaWrapper.querySelector(`[data-variant-color="${colorValue}"]`);
    if (targetImage) {
      console.log('Switching to variant image for color:', colorValue);
      // Hide primary image
      if (primaryImage) {
        primaryImage.style.display = 'none';
      }
      // Show variant image
      targetImage.style.display = 'block';

      // Add transition effect
      mediaWrapper.classList.add('image-swapping');
      setTimeout(() => {
        mediaWrapper.classList.remove('image-swapping');
      }, 300);
    } else {
      console.warn('No variant image found for color:', colorValue);
    }

    // Update active state on swatches
    const allSwatches = productCard.querySelectorAll('.color-swatch-trigger');
    allSwatches.forEach(swatch => {
      swatch.classList.remove('active');
    });
    swatchLink.classList.add('active');
  }, true); // Use capture phase to ensure we catch the event first
});
